var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_14)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9771 1.71428C15.9927 1.52421 16.0003 1.33357 16 1.14286V9.52961e-08H14C12.5161 -0.000247211 11.0722 0.480858 9.88502 1.37108C8.69785 2.26131 7.83148 3.51262 7.41599 4.93714C6.77557 4.11104 5.95447 3.44256 5.01567 2.98296C4.07686 2.52336 3.04527 2.28485 2 2.28571H0V3.42857C0 5.2472 0.722447 6.99134 2.00841 8.2773C3.29437 9.56326 5.03851 10.2857 6.85714 10.2857H7.14285V15.1428C7.14285 15.3702 7.23316 15.5882 7.3939 15.7489C7.55465 15.9097 7.77267 16 7.99999 16C8.22732 16 8.44534 15.9097 8.60608 15.7489C8.76683 15.5882 8.85714 15.3702 8.85714 15.1428V8H9.14285C10.8627 8.00024 12.5199 7.35418 13.7858 6.18991C15.0517 5.02564 15.8338 3.42818 15.9771 1.71428ZM8.88799 6.28571C9.02857 5.02835 9.6277 3.86693 10.5708 3.02355C11.5139 2.18018 12.7348 1.71404 14 1.71428H14.2548C14.1143 2.97165 13.5151 4.13307 12.572 4.97644C11.6289 5.81982 10.408 6.28595 9.14285 6.28571H8.88799ZM2 4C3.26519 3.99975 4.48608 4.46589 5.42919 5.30927C6.37229 6.15264 6.97142 7.31406 7.11199 8.57142H6.85714C5.59194 8.57167 4.37105 8.10553 3.42795 7.26216C2.48485 6.41878 1.88572 5.25736 1.74514 4H2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/stress.a07a1705a3816221bd603a4bff7bac89.svg";
export { ForwardRef as ReactComponent };